import { ReactElement } from "react";

import { Button } from "react-bulma-components";

import { getMonthString, hyphenedYM } from "helpers/date";
import { useQuery } from "hooks/router";

interface MoveMonthButtonGroupProps {
  untilThisMonth?: boolean;
}

const nextButtonQuery = (untilThisMonth: boolean) => {
  if (!untilThisMonth) return `?month=${getMonthString(1)}`;
  const thisMonthYM = hyphenedYM(new Date());
  const nextMonthYM = getMonthString(+1);
  return thisMonthYM === nextMonthYM ? "" : `?month=${getMonthString(1)}`;
};

export function MoveMonthButtonGroup({
  untilThisMonth,
}: MoveMonthButtonGroupProps): ReactElement | null {
  const query = useQuery();
  const monthInParams = query.get("month");

  const disableNextButton = untilThisMonth && !monthInParams;

  return (
    <div className="buttons has-addons">
      <Button
        onClick={() => {
          window.location.href = `${
            window.location.pathname
          }?month=${getMonthString(-1)}`;
        }}
      >
        &lt;&lt; 前月
      </Button>
      <Button
        disabled={disableNextButton}
        onClick={() => {
          window.location.href = `${window.location.pathname}${nextButtonQuery(
            !!untilThisMonth
          )}`;
        }}
      >
        次月 &gt;&gt;
      </Button>
    </div>
  );
}
